
import React, { createContext, useContext, useState } from 'react';
import { Project, WorkStatus } from '@/types/project';

interface ScheduleContextType {
  selectedProject: Project | null;
  setSelectedProject: (project: Project | null) => void;
}

const ScheduleContext = createContext<ScheduleContextType | undefined>(undefined);

export function useSchedule(): ScheduleContextType {
  const context = useContext(ScheduleContext);
  if (!context) {
    throw new Error('useSchedule must be used within a ScheduleProvider');
  }
  return context;
}

export function ScheduleProvider({ children }: { children: React.ReactNode }) {
  const [selectedProject, setSelectedProject] = useState<Project | null>(null);

  return (
    <ScheduleContext.Provider value={{ selectedProject, setSelectedProject }}>
      {children}
    </ScheduleContext.Provider>
  );
}
